import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const DEPOSIT_TOGGLE_VALUE_SCHEMA = Object.freeze({
  VALUE: 0,
  TOGGLE_STATE: false,
});
const RECORD = generateSchema(DEPOSIT_TOGGLE_VALUE_SCHEMA);
const KEYS: any = generateKeys(DEPOSIT_TOGGLE_VALUE_SCHEMA);

export class DepositToggleValue extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get value(): number {
    return this.get(KEYS.VALUE);
  }

  get toggleState(): boolean {
    return this.get(KEYS.TOGGLE_STATE);
  }
}
